import {
  ExternalDeviceItem,
  ExternalDeviceSourceItem,
  ExternalDevicesResult,
  ExternalDeviceType
} from "./ExternalDevices.model";

export class ExternalDevicesUtils {
  static getDevicePrefix (model?: string | null) {
    if (!model) return;

    const modelLower = model.toLowerCase();
    if (modelLower.includes('naos')) return 'V';
    if (modelLower.includes('titan')) return 'М';
    if (modelLower.includes('altair.s')) return 'S';
    if (modelLower.includes('altair.d')) return 'D';
    if (modelLower.includes('inunki')) return 'N';

    return '';
  };

  static formatDeviceSerialNumber(
    serialNumber?: string | number | null,
    type?: string | number,
    model?: string | null
  ) {
    const serial = String(serialNumber ?? '').trim();

    if (!serial || !/^\d+$/.test(serial)) {
      return serial;
    }

    const prefixes: Record<string, string> = {
      [ExternalDeviceType.DimmerD]: 'D',
      [ExternalDeviceType.DimmerS]: 'S',
      [ExternalDeviceType.ClockMechanicE]: 'E',
      [ExternalDeviceType.ClockMechanicN]: 'N',
      [ExternalDeviceType.ClockMechanicV]: 'V',
      [ExternalDeviceType.ElectronicClock]: 'E',
      [ExternalDeviceType.LedPanel]: 'Y',
      [ExternalDeviceType.UpsI]: 'W',
      [ExternalDeviceType.SensorBlockT]: 'T',
    };

    const modelPrefix = ExternalDevicesUtils.getDevicePrefix(model);
    const prefix = modelPrefix || prefixes[String(type)] || '';

    return `${prefix}${serial.padStart(4, '0')}`;
  }

  static normalizeAccordionKey(nextKey: string | number | undefined): number {
    return nextKey == null ? -1 : Number(nextKey);
  }

  static getSelectedDeviceIndex(
    devices: ExternalDeviceItem[],
    selectedDeviceId?: string | number | null
  ): number {
    if (!selectedDeviceId) {
      return -1;
    }

    const idx = devices.findIndex((device) => device.id === selectedDeviceId);
    return idx >= 0 ? idx : -1;
  }

  static mapExternalDevice(
    device: ExternalDeviceSourceItem,
    deviceDescription: string,
    prefix: string
  ): ExternalDeviceItem {
    const address = device.address ?? 0;

    return {
      text: `${device.model ?? ""} | ${deviceDescription} | ${prefix}${address.toString().padStart(4, '0')}`,
      address,
      type: device.type ?? "",
      id: device.id ?? "",
      isConnected: device.isConnected ?? false,
      isVisible: device.isVisible ?? false,
    };
  }

  static buildDeviceAddresses(result: ExternalDevicesResult): ExternalDeviceItem[] {
    const dimmers = result.dimmers ?? [];
    const clocks = result.clocks ?? [];
    const electronicClocks = result.electronicClocks ?? [];
    const ledPanels = result.ledPanels ?? [];
    const upsDevices = result.ups ?? [];
    const sensors = result.sensors ?? [];

    return [
      ...dimmers.map((device) =>
        ExternalDevicesUtils.mapExternalDevice(
          device,
          "Управление светом",
          ExternalDevicesUtils.getDevicePrefix(device.model) ?? ""
        )
      ),
      ...clocks.map((device) =>
        ExternalDevicesUtils.mapExternalDevice(
          device,
          "Умный часовой механизм",
          ExternalDevicesUtils.getDevicePrefix(device.model) ?? ""
        )
      ),
      ...electronicClocks.map((device) =>
        ExternalDevicesUtils.mapExternalDevice(device, "Электронные часы", "E")
      ),
      ...ledPanels.map((device) =>
        ExternalDevicesUtils.mapExternalDevice(device, "LED-экран", "Y")
      ),
      ...upsDevices.map((device) =>
        ExternalDevicesUtils.mapExternalDevice(device, "ИБП", "W")
      ),
      ...sensors.map((device) =>
        ExternalDevicesUtils.mapExternalDevice(device, "Блок датчиков", "T")
      ),
    ];
  }
}
